<script>
import {mapGetters} from "vuex";
import moment from "moment/moment";
import Swal from "sweetalert2";

export default {
    name: "single-table",

    props: {
        updateKey: {
            type: Number
        }
    },

    computed: {
        ...mapGetters({
            messages: 'sms/singleList',
            loading: 'sms/singleLoading',
            paginator: 'sms/singlePager',
        }),

        fields: function () {
            return [
                {
                    key: "id",
                    label: '#',
                    thClass: 'gridjs-th',
                    sortable: true
                },
                {
                    key: "phone",
                    label: this.$t('sms.phone'),
                    thClass: 'gridjs-th border-left-0',
                    sortable: true
                },
                {
                    key: "sent_status",
                    label: this.$t('sms.status'),
                    thClass: 'gridjs-th border-left-0',
                    tdClass: 'cursor-pointer',
                    formatter: (value) => this.$t('sms.' + value?.toLowerCase()),
                    sortable: true
                },
                {
                    key: "create_date",
                    label: this.$t('sms.create_date'),
                    thClass: 'gridjs-th border-left-0',
                    formatter: (value) => {
                        return moment(value).format('YYYY. MM. DD. HH:mm')
                    },
                    sortable: true
                },
                {
                    key: "sent_date",
                    label: this.$t('sms.sent_date'),
                    thClass: 'gridjs-th border-left-0',
                    tdClass: 'text-start',
                    formatter: (value) => {
                        return value ? moment(value).format('YYYY. MM. DD. HH:mm') : value
                    },
                    sortable: true
                },
                {
                    key: "actions",
                    label: '',
                    thClass: 'gridjs-th',
                    tdClass: 'text-end'
                },
            ];
        },
    },

    data: function () {
        return {
            sortBy: 'id',
            sortDesc: true,
        };
    },

    methods: {
        toPage: function (val) {
            this.page = val
            this.delayedFetch();
        },

        delayedFetch: function () {
            this.$store.dispatch('sms/fetchSingleDelayed', {
                limit: this.perPage,
                offset: this.pager && this.pager.offset,
                page: this.page,
                sorting: {
                    column: this.sortBy,
                    desc: this.sortDesc
                }
            });
        },

        showMessage: function (message) {
            Swal.fire({
                html: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success btn-md'
                }
            })
        },

        showHistory: function (item) {
            let message = `<ul class="list-unstyled"><li class="mb-3"><i class="fas fa-plus-circle me-2"></i><strong>${this.$t('sms.create_date')}</strong><br><small>${item.create_date.formattedDate()}</small></li>`;

            if (item.timing_date && item.timing_date !== item.create_date) {
                message += `<li class="mb-3"><i class="fas fa-clock text-warning me-2"></i><strong>${this.$t('sms.timing_date')}</strong><br><small>${item.timing_date.formattedDate()}</small></li>`;
            }

            if (item.canceled_at) {
                message += `<li class="mb-3"><i class="fas fa-times text-danger me-2"></i><strong>${this.$t('sms.cancelled')}</strong><br><small>${item.canceled_at.formattedDate()}</small></li>`;
            }

            if (item.sent_date) {
                message += `<li class="mb-3"><i class="fas fa-sms text-success me-2"></i><strong>${this.$t('sms.sent')}</strong><br><small>${item.sent_date.formattedDate()}</small></li>`;
            }

            message += '</ul>';

            Swal.fire({
                html: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success btn-md'
                }
            });
        },

        revoke: function (id) {
            Swal.fire({
                title: this.$t('table.confirm'),
                text: this.$t('sms.confirm_revoke'),
                icon: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-warning btn-md me-1',
                    cancelButton: 'btn btn-primary btn-md ms-1',
                },
                confirmButtonText: this.$t('table.yes'),
                cancelButtonText: this.$t('table.no')
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch('sms/cancel', id).then(() => {
                        Swal.fire(
                            this.$t('sms.message_revoked'),
                            this.$t('sms.selected_item_is_revoked'),
                            'success'
                        )
                    }).catch(() => {});
                }
            })
        },

        getTitle: function (item) {
            if (item.sent_status === 'WAITING' && item.create_date !== item.timing_date) {
                return this.$t('sms.timing_date') + ' (' + item.timing_date.formattedDate() + ')';
            }

            if (item.sent_status === 'WAITING' && item.create_date === item.timing_date) {
                return this.$t('sms.waiting') + ' (' + item.timing_date.formattedDate() + ')';
            }

            if (item.sent_status === 'CANCELLED' && item.canceled_at) {
                return this.$t('sms.cancelled') + ' (' + item.canceled_at.formattedDate() + ')';
            }

            if (item.sent_status === 'SENT' || item.sent_status === 'OK') {
                return this.$t('sms.sent') + ' (' + item.sent_date.formattedDate() + ')';
            }

            if (item.sent_status === 'WAIT') {
                return this.$t('sms.wait');
            }

            if (item.sent_status === 'UNDEL') {
                return this.$t('sms.undel');
            }

            if (item.sent_status === 'NOSTATUS') {
                return this.$t('sms.nostatus');
            }

            if (item.sent_status === 'EXP') {
                return this.$t('sms.error');
            }

            if (item.sent_status === 'ERROR') {
                return this.$t('sms.error');
            }
        },

        rowColor: function (item) {
            if (!item) {
                return;
            }

            if (item.sent_status === 'CANCELLED' && item.canceled_at) {
                return 'bg-danger-subtle';
            }

            if (item.sent_status === 'SENT' || item.sent_status === 'OK') {
                return 'bg-success-subtle';
            }

            if (item.sent_status === 'EXP') {
                return 'bg-danger-subtle';
            }

            if (item.sent_status === 'UNDEL') {
                return 'bg-danger-subtle';
            }

            if (item.sent_status === 'ERROR') {
                return 'bg-danger-subtle';
            }
        },
    },

    watch: {
        sortBy: function () {
            this.delayedFetch();
        },
        sortDesc: function () {
            this.delayedFetch();
        },
        updateKey: function () {
            this.delayedFetch();
        },
    },

    created() {
        this.$store.dispatch('sms/fetchSingle', {
            limit: this.perPage,
            offset: this.pager && this.pager.offset,
            page: this.page,
            sorting: {
                column: this.sortBy,
                desc: this.sortDesc
            }
        });
    },
}
</script>

<template>
    <div class="list-table-wrapper">
        <div class="table-responsive mb-0">
            <b-table
                :items="messages"
                :fields="fields"
                responsive="sm"
                :per-page="paginator.perPage"
                :current-page="paginator.currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                show-empty
                :empty-text="$t('table.please_select_or_empty')"
                hover
                head-variant="light"
                :busy="loading"
                no-local-sorting
                :tbody-tr-class="rowColor"
            >
                <template #table-busy>
                    <div class="text-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $t('table.loading') }}...</span>
                        </div>
                    </div>
                </template>
                <template #cell(is_deleted)="scope">
                    <i v-if="Number(scope.value) === 1" class="fa fa-trash-alt text-danger"></i>
                </template>
                <template #cell(sent_status)="scope">
                    <div :title="getTitle(scope.item)">
                        <i v-if="scope.unformatted === 'WAITING' && scope.item.create_date !== scope.item.timing_date" class="fas fa-clock text-warning"></i>
                        <i v-else-if="scope.unformatted === 'WAITING' && scope.item.create_date === scope.item.timing_date" class="fas fa-hourglass-half"></i>
                        <i v-else-if="scope.unformatted === 'CANCELLED' && scope.item.canceled_at" class="fas fa-times-circle text-danger"></i>
                        <i v-else-if="scope.unformatted === 'SENT' || scope.unformatted === 'OK'" class="fas fa-check-circle text-success"></i>
                        <i v-else-if="scope.unformatted === 'EXP'" class="fas fa-exclamation-circle text-danger"></i>
                        <i v-else-if="scope.unformatted === 'WAIT'" class="fas fa-hourglass-end text-warning"></i>
                        <i v-else-if="scope.unformatted === 'UNDEL'" class="fas fa-exclamation-triangle text-danger"></i>
                        <i v-else-if="scope.unformatted === 'ERROR'" class="fas fa-exclamation-triangle text-danger"></i>
                        <i v-else-if="scope.unformatted === 'NOSTATUS'" class="fas fa-question-circle text-secondary"></i>
                        <span class="ms-2">{{ scope.value }}</span>
                    </div>
                </template>
                <template #cell(actions)="scope">
                    <div class="d-inline-flex">
                        <b-button class="me-2" v-b-tooltip.hover.top="$t('sms.create_date') + ': ' + scope.item.create_date.formattedDate()" size="sm" variant="secondary" @click="showHistory(scope.item)">
                            <i class="fas fa-calendar-plus"></i>
                        </b-button>
                        <b-button class="me-2" v-b-tooltip.hover.top="$t('sms.message')" size="sm" variant="primary" @click="showMessage(scope.item.sms)">
                            <i class="fas fa-comment"></i>
                        </b-button>
                        <b-button v-if="!scope.item.sent_date && !scope.item.canceled_at" v-b-tooltip.hover.top="$t('sms.revoke')" size="sm" variant="danger" @click="revoke(scope.item.id)">
                            <i class="fas fa-times-circle"></i>
                        </b-button>
                        <span v-else class="d-inline-block" style="width: 31px; height: 29px;"></span>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row mb-3 mx-2">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="paginator.current_page"
                            :limit="paginator.limit"
                            :total-rows="paginator.count"
                            :per-page="paginator.limit"
                            @change="toPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>